import React from "react";
import { AppContainerComponent } from "portal/AppContainer";

function App() {
  return <AppContainerComponent></AppContainerComponent>;
}

export default App;
